<!--
  ~ Copyright (c) Worldline 2023.
  -->

<!DOCTYPE html>

<main role="main">
    <h2>
        {{ '404.title' | translate }}
    </h2>
    <section class="infoBox">
        <p>{{'404.infoBox.1' | translate }}</p>
        <p>{{'404.infoBox.2' | translate }}</p>
        <ul>
            <li>{{ '404.infoBox.list.1' | translate }}</li>
            <li>{{ '404.infoBox.list.2' | translate }}</li>
        </ul>
    </section>
</main>
